import React from "react"
import {Link} from "react-router-dom"


export default function HomePage() {

    return <section>
        <h1>Sailweek Academy</h1>

        <div>
            <Link to="/apply" className="btn btn-primary">Apply</Link>
        </div>
    </section>
}
